import {RoleService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        roles: []
    },

    mutations: {
        saveRoles(state, roles) {
            state.roles.splice(0);
            state.roles = [...roles];
        }
    },

    actions: {
        async getRolesAction({commit}) {
            await bindLoading(commit,
                async () => commit('saveRoles', await RoleService.getAll()), 'role');
        },

        async removeRoleAction({commit, state}, id) {
            return await bindLoading(commit,
                async () => {
                    const res = await RoleService.remove(id);
                    if (res.success) {
                        commit('saveRoles', state.roles.filter(f => f.id !== id));
                    }
                    return res;
                }, 'role');
        },

        async addRoleAction({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await RoleService.insert(item);
                    if (res.success) {
                        commit('saveRoles', [...state.roles, res.instance]);
                    }
                    return res;
                }, 'role');
        },

        async updateRoleAction({commit, state}, item) {
            return await bindLoading(commit,
                async () => {
                    const res = await RoleService.update(item);
                    if (res.success) {
                        const idx = state.roles.findIndex(m => m.id === item.id);
                        commit('saveRoles',
                            [
                                ...state.roles.filter((_, i) => i < idx),
                                res.instance,
                                ...state.roles.filter((_, i) => i > idx)
                            ]);
                    }
                    return res;
                }, 'role');
        }
    }

}